import { camelCase, isEmpty } from 'lodash';

import {
  capitalizeString,
  convertCurrencyStrToNum,
  convertNumToCurrencyStr,
} from '../../../utils/globalHelpers';

/**
 * @description returns translated react-intl message if set for the payment transaction description,
 * or else returns the capitalized  as transactions description
 */
export const formatPaymentTransactionType = ({ intl, transactionDescription }) => {
  const intlId = `payments.history.transactions.type.${camelCase(transactionDescription)}`;
  if (intl.messages[intlId]) {
    return intl.formatMessage({ id: intlId });
  }
  return capitalizeString(transactionDescription);
};

/**
 * @description reformats sorted transactions array to group transactions made on the same day
 * and classified as "Other"
 */
export const generateGroupedTransactions = (transactions) => transactions.reduce((
  groupedTransactions,
  transaction,
) => {
  if (isEmpty(groupedTransactions)) {
    groupedTransactions.push([transaction]);
  } else {
    const lastGroupIndex = groupedTransactions.length - 1;
    const lastGroup = groupedTransactions[lastGroupIndex];
    const {
      category: lastTransactionCategory,
      date: lastTransactionDate,
    } = lastGroup[lastGroup.length - 1];
    const { category, date } = transaction;

    if (
      date === lastTransactionDate
        && category === 'Other'
        && lastTransactionCategory === 'Other'
    ) {
      // Add to transaction to last group
      groupedTransactions[lastGroupIndex].push(transaction);
    } else {
      // Start a next transaction group
      groupedTransactions.push([transaction]);
    }
  }
  return groupedTransactions;
}, []);

/**
 * @description formats props for grouped/same-day transactions
 */
export const generateTotalPaymentsProps = (transactions) => {
  const totalPayments = convertNumToCurrencyStr(transactions.reduce(
    (accumulator, { amount }) => accumulator + convertCurrencyStrToNum(amount),
    0,
  ));
  return {
    amount: totalPayments,
    date: transactions[0].date,
    id: transactions[0].id,
    type: 'Multiple Payments',
  };
};

/**
 * @description Parse down the grouped transactions to only include the first 3,
 * and only include the relevant properties
 * @param {object[]} transactions
 */
export const parseHomeTransactions = (transactions) =>
  transactions.slice(0, 3).map((transaction) => {
    const {
      amount,
      date,
      id,
    } = transaction.length > 1 ? generateTotalPaymentsProps(transaction) : transaction[0];

    return { amount, date, id };
  });
